import {useLayoutEffect, useRef, DependencyList, EffectCallback} from 'react';

export function useUpdateLayoutEffect(effect: EffectCallback, deps: DependencyList = []) {
    const isInit = useRef(true);

    useLayoutEffect(
        () => {
            if (isInit.current === true) {
                isInit.current = false;
                return;
            }
            return effect();
        },

        deps,
    );
}
